var map = {
	"./brandico.json": "931f",
	"./entypo.json": "bd75",
	"./font-awesome.json": "9b25",
	"./fontelico.json": "cd43",
	"./glyphicons.json": "bf66",
	"./iconic-stroke.json": "870e",
	"./ionicons.json": "a322",
	"./maki.json": "88e0",
	"./material-icons.json": "e33b",
	"./openweb.json": "3f67",
	"./typicons.json": "3ec0",
	"./vuestic.json": "eed3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a32";